export function getPathFromHeader(currentPath, selectedLocation, header) {
    let path = "";
    if (header && header.locations && currentPath) {
        const relLoc = header.locations[selectedLocation].relativeLocation;
        path = currentPath.split(relLoc)[1];
        if (path && path.startsWith("/")) {
            path = path.slice(1);
        }
    }
    return path;
}
//# sourceMappingURL=utils.js.map